module.exports = __webpack_public_path__ + "img/dobro_darom_logo.73a3bdf7.png";